"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var CenterRange = /** @class */ (function (_super) {
    __extends(CenterRange, _super);
    function CenterRange() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genClasses = function (position, isDisable) {
            var classes = "page-btn item-btn " + _this.props.isActive(position);
            classes += isDisable ? ' disable' : '';
            return classes;
        };
        return _this;
    }
    CenterRange.prototype.render = function () {
        var _this = this;
        var _a = this.props, centerRange = _a.centerRange, alphabetical = _a.alphabetical, onPageChangeHandle = _a.onPageChangeHandle, isPageDisabled = _a.isPageDisabled;
        return (React.createElement(React.Fragment, null, centerRange.map(function (page) {
            var activePosition = page + 1;
            var letter = String.fromCharCode(97 + page);
            var value = alphabetical ? letter : activePosition;
            var isDisabled = isPageDisabled(value);
            return (React.createElement("div", { key: value, className: "" + _this.genClasses(activePosition, isDisabled), onClick: function () {
                    if (!isDisabled) {
                        onPageChangeHandle(activePosition);
                    }
                } }, value));
        })));
    };
    return CenterRange;
}(React.Component));
exports.default = CenterRange;
